"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _icons = require("@ori-ui/icons");
const styleOverrides = {
  standard: {
    '&:focus': {
      backgroundColor: 'unset'
    }
  },
  outlined: ({
    theme
  }) => ({
    borderRadius: theme.shape.borderRadius
  })
};
const defaultProps = {
  IconComponent: _icons.ArrowDownThin,
  MenuProps: {
    elevation: 0,
    classes: {
      paper: 'OriSelectPaper',
      list: 'OriSelectList'
    },
    BackdropProps: {
      invisible: true
    }
  }
};
var _default = exports.default = {
  styleOverrides,
  defaultProps
};
